import { Vector3D } from '@awayjs/core';
/**
 * Value object ___ for a picking collision returned by a picking collider. Created as unique objects on display objects
 *
 * @see away.base.DisplayObject#pickingCollision
 *
 * @class away.pick.PickingCollision
 */
var PickingCollision = /** @class */ (function () {
    /**
     * Creates a new <code>PickingCollision</code> object.
     *
     * @param entity The entity to which this collision object belongs.
     */
    function PickingCollision(entityNode, pickGroup) {
        /**
         * The local normal vector at the position of the collision.
         */
        this.normal = new Vector3D();
        /**
         * The starting position of the colliding ray in local coordinates.
         */
        this.rayPosition = new Vector3D();
        /**
         * The direction of the colliding ray in local coordinates.
         */
        this.rayDirection = new Vector3D();
        this.entityNode = entityNode;
        this.pickGroup = pickGroup;
    }
    return PickingCollision;
}());
export { PickingCollision };
